import React, {useState} from 'react'
import {Helmet} from "react-helmet";
import {DocsHeader} from "../components/DocsHeader";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from "react-bootstrap/Button";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Helpers from 'react-bootstrap/helpers';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWindows} from '@fortawesome/free-brands-svg-icons';
import {faCircleExclamation} from '@fortawesome/free-solid-svg-icons';
import {faCopy} from '@fortawesome/free-solid-svg-icons';
import {emojiGroups} from '../EmojiList';

export function EmojiPage() {

    const [value, setValue] = useState('');



    const seoData = {
        title: 'Онлайн эмодзи для набора с компьютера, скопировать эмодзи, клавиатура эмодзи',
        description: 'Набрать смайлы эмодзи/эмоджи на компьютере. Коды не нужны!',
        site_name: 'Keybd.ru'
    }

    const changeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValue(event.target.value);
    }

    function handleClick (text: string) {
        setValue(value + text);
    }

    function clearForms() {
        setValue('');
    }

    return (
        <>
            <Helmet>
                <title>{seoData.title}</title>
                <link rel="canonical" href="https://keybd.ru/emoji" />
                <meta name="description" content={seoData.description} />
                <meta property="og:locale" content="ru_RU" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={seoData.title} />
                <meta property="og:description" content={seoData.description} />
                <meta property="og:url" content="https://keybd.ru/emoji" />
                <meta property="og:site_name" content={seoData.site_name} />
                <meta property="og:image" content="/logo512.png"></meta>
                <meta property="og:image:type" content="image/png" />
            </Helmet>
            <DocsHeader title="Клавиатура эмодзи (Emoji)" lead="Эмодзи — это цветные пиктограммы, которые используются в тексте для выражения эмоций." />
            <main>
                <Container>

                    <Form className="emoji-form mb-1 sticky-top" id="convert-form">
                        <Row>
                            <Col sm={12}>
                                <fieldset className="my-3">
                                    <Form.Control
                                        value={value}
                                        onChange={changeHandler}
                                        as="textarea"
                                        name="coded"
                                        cols={50}
                                        rows={3} />
                                </fieldset>
                                <fieldset className="mb-3 text-end">
                                    <Button
                                        onClick={() => {navigator.clipboard.writeText(value)}}
                                        variant="light"
                                        type="button"
                                        className="me-2"
                                        >
                                        <FontAwesomeIcon icon={faCopy} title="copy" /> Копировать
                                    </Button>
                                    <Button variant="light" onClick={clearForms}>
                                        Очистить
                                    </Button>
                                </fieldset>
                            </Col>
                        </Row>
                    </Form>

                    <div className="emoji">
                        <Tabs
                            defaultActiveKey="tab0"
                            id="tab-example"
                            // className="mb-3"
                        >
                            {emojiGroups.map((group, index) =>
                                <Tab key={index} as="section" eventKey={'tab' + index} title={group.title}>
                                    <p>
                                        {Object.keys(group.content).map((value, index) => (
                                          <span key={index} title={group.content[value as keyof typeof group.content]} onClick={() => handleClick(value)}>{value}</span>
                                        ))}

                                    </p>
                                </Tab>
                            )}

                        </Tabs>
                    </div>
                    <Alert key="info" variant="info">
                        <p>
                            Нажмите на понравившиеся <strong>эмодзи</strong><span
                            className="emoji"> 😊 </span>, чтобы добавить их в поле выше. Затем скопируйте
                            всё поле.
                        </p>
                        <p className="d-none d-md-block mb-0">
                            На <strong>Windows 10</strong> и выше нажмите на клавиатуре
                            {' '}<kbd>
                                <FontAwesomeIcon icon={faWindows} title="Win" />
                                 + ;
                            </kbd>{' '}
                            или 
                            <kbd>
                                <FontAwesomeIcon icon={faWindows} title="Win" />
                                 + .
                            </kbd>{' '}
                            — появится панель с эмодзи.
                        </p>
                    </Alert>
                    <Alert key="warning" variant="warning">
                        <FontAwesomeIcon icon={faCircleExclamation} />
                          Внешний вид emoji может отличаться в зависимости от вашего устройства и приложения.
                    </Alert>
                    <br/><br/>
                </Container>
            </main>
        </>
    )
}